/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Log_DateInputs */

const vi_care_log_log_date = /** @type {(inputs: Care_Log_Log_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày thực hiện`)
};

/**

* @param {Care_Log_Log_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_log_date = /** @type {((inputs?: Care_Log_Log_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Log_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_log_date(inputs)
});